import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridCsvExportButtonComponent } from './csv-export-button.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AgGridCsvExportButtonComponent],
  imports: [CommonModule, TranslateModule],
  exports: [AgGridCsvExportButtonComponent],
})
export class CsvExportModule {}
